let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2WXiI")).then(() => parcelRequire('iJf7c'));